module.exports = __webpack_public_path__ + "static/media/wsymbol_0003_white_cloud_big_s1.26670eaf.png";